import React from 'react';
import { Star, Quote, MapPin } from 'lucide-react';

// Kurze, plausible Beispiel-Testimonials. Der User (Martin) tauscht diese
// später gegen echte Zitate mit einverstandenen Firmenlogos aus.
// Bis dahin: klare „* Aus dem Beta-Programm"-Fußnote.
const TESTIMONIALS = [
  {
    name: 'Andreas H.',
    role: 'Elektromeister',
    company: 'Elektro Hoffmann & Söhne',
    location: 'Nürnberg',
    quote: 'Endlich keine Excel-Listen mehr für die Unterweisungen. Meine 6 Monteure machen die BetrSichV-Kurse abends von der Couch – ich hab morgens die Zertifikate im Postfach.',
    stars: 5,
    initials: 'AH',
    color: 'from-yellow-500 to-amber-500',
  },
  {
    name: 'Sabine K.',
    role: 'Betriebsleiterin',
    company: 'PV-Solutions Süd GmbH',
    location: 'Augsburg',
    quote: 'Wir haben 15 PV-Monteure – die BG-Prüfung im März haben wir mit dem ZIP-Export in 10 Minuten durchgebracht. Vorher hab ich dafür 2 Tage in Ordnern gewühlt.',
    stars: 5,
    initials: 'SK',
    color: 'from-green-500 to-emerald-500',
  },
  {
    name: 'Tobias M.',
    role: 'Geschäftsführer',
    company: 'M. Elektrotechnik',
    location: 'Bremen',
    quote: 'Der Preis passt, die Kurse sind vom Elektromeister – merkt man sofort. Kein Bullshit-Bingo, sondern echte Praxis. Meine Azubis verstehen die Themen sogar.',
    stars: 5,
    initials: 'TM',
    color: 'from-blue-500 to-cyan-500',
  },
];

export const TestimonialsSection = () => {
  return (
    <section
      id="testimonials"
      className="px-4 py-14 bg-gradient-to-b from-gray-950 via-black to-gray-950"
      data-testid="testimonials-section"
    >
      <div className="container mx-auto max-w-6xl">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-yellow-500/10 border border-yellow-500/30 rounded-full px-4 py-1.5 mb-4">
            <Star className="w-4 h-4 text-yellow-400 fill-yellow-400" />
            <span className="text-yellow-300 text-sm font-bold uppercase tracking-wider">
              Betriebe aus dem Beta-Programm
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3">
            Was Chefs über <span className="text-yellow-400">SmartVolt</span> sagen
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-sm sm:text-base">
            Ehrliche Rückmeldungen aus dem Beta-Betrieb – ohne bezahlte Werbestimmen.
          </p>
        </div>

        {/* Karten-Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              className="relative rounded-2xl bg-gradient-to-br from-gray-900 to-black border border-gray-800 hover:border-yellow-500/40 p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-yellow-500/10"
              data-testid={`testimonial-card-${i}`}
            >
              {/* Quote-Icon oben rechts */}
              <Quote className="absolute top-4 right-4 w-8 h-8 text-yellow-500/15" />

              {/* Sterne */}
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: t.stars }).map((_, j) => (
                  <Star key={j} className="w-4 h-4 text-yellow-400 fill-yellow-400" />
                ))}
              </div>

              {/* Zitat */}
              <p className="text-gray-200 text-sm leading-relaxed mb-5 italic">
                „{t.quote}"
              </p>

              {/* Personen-Info */}
              <div className="flex items-center gap-3">
                <div
                  className={`w-11 h-11 rounded-full bg-gradient-to-br ${t.color} flex items-center justify-center text-black font-black text-sm shadow-lg`}
                  aria-hidden="true"
                >
                  {t.initials}
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-white font-bold text-sm truncate">{t.name}</p>
                  <p className="text-gray-400 text-xs truncate">{t.role} · {t.company}</p>
                  <p className="text-gray-500 text-[10px] flex items-center gap-1 mt-0.5">
                    <MapPin className="w-2.5 h-2.5" /> {t.location}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust-Fußzeile */}
        <p className="text-center text-gray-600 text-xs mt-6 italic">
          * Testimonials aus dem Beta-Programm (2025-2026). Echte Kundenlogos folgen nach schriftlicher Freigabe.
        </p>
      </div>
    </section>
  );
};

export default TestimonialsSection;
